<template  >
    <div >
         <template v-for="item in products">
          <product-component v-bind:key="item.eightd" :goods='item'  />
        </template>
    </div>
</template>
<style>
</style>
<script>
import ProductComponent from "./common/ProductComponent";
export default {
  data() {
    return {
      api: this.$store.state.api,
      products: []
    };
  },
  components: {
    ProductComponent
  },

  created() {

    let pds = this.$router.currentRoute.params.products;
    pds.forEach(element => {
      this.products.push(element);
    });

  }
};
</script>



// WEBPACK FOOTER //
// src/components/FilterResult.vue